import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import moment from "moment";

import Button from "../../components/Button";
import { Card, CardContent } from "../../components/Card";
import { TextInput, DateInput } from "../../components/Form";
import Table from "../../components/Table";

export default function StudentManageTable({onChangeSelect=()=>{}}) {
  const datatest = [
    {
      studentID: "100055881",
      name: "bo",
      phone: "0952365472",
      title: "法拍屋入門實戰",
      date: new Date(),
      deposit: "1500",
    },
  ];
  const [newData, setNewData] = useState({
    searchID: "",
    date: null,
    opne: false,
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item>
            <TextInput
              value={newData.searchID}
              label={"編號搜尋"}
              onChange={(value) => {
                changeData("searchID", value, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Table
              data={datatest}
              tableWidth={2}
              header={[
                "客戶編號",
                "學員姓名",
                "連絡電話",
                "近期課程",
                "近期課程訂金",
                "近期課程檔期",
                // "操作",
              ]}
              columns={[
                "studentID",
                "name",
                "phone",
                "title",
                "deposit",
                (item) => moment(item.date).format("yyyy-MM-DD"),
                // (item) => (
                //   <Button
                //     color="primary"
                //     variant="contained"
                //     onPress={() => {
                //       changeData("open", true);
                //       changeData("date", item.date, true);
                //     }}
                //   >
                //     編輯
                //   </Button>
                // ),
              ]}
              onPress={(item) => {onChangeSelect(item)}}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

function EditDialog({ open, onClose = () => {} }) {
  const datatest = [
    {
      studentID: "a84121",
      name: "bo",
      phone: "0952365472",
      title: "法拍屋入門實戰",
      date: new Date(),
      deposit: "1500",
    },
  ];
  const [newData, setNewData] = useState({
    date: null,
    opne: false,
  });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  return (
    <Dialog
      open={newData.open}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={"xs"}
    >
      <DialogContent>
        <Grid item>
          <Typography color="primary">學員編號</Typography>
          <Typography>{datatest[0].studentID}</Typography>
        </Grid>
        <Grid item>
          <Typography color="primary">學員姓名</Typography>
          <Typography>{datatest[0].name}</Typography>
        </Grid>
        <Grid item>
          <Typography color="primary">連絡電話</Typography>
          <Typography>{datatest[0].phone}</Typography>
        </Grid>
        <Grid item>
          <Typography color="primary">參加課程檔期</Typography>
          <DateInput
            value={newData.date}
            inputVariant="outlined"
            format="yyyy年MM月dd日"
            onChange={(v) => {
              changeData("date", v, true);
            }}
            fullWidth
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button
              color="primary"
              variant="outlined"
              onPress={() => {
                changeData("open", false, true);
              }}
            >
              返回
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onPress={() => {
                changeData("open", false, true);
              }}
            >
              儲存
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
